export const PENDING_IMAGES_MESSAGE =
  'You have uploaded previously images, do you want to continue work with them or upload additional ones?';

export const CONTINUE_WITH_EXISTING_LABEL = 'Continue work with existing';
export const UPLOAD_ADDITIONAL_LABEL = 'Upload additional ones';
